import React, { useState } from 'react';
import Text from '../../atoms/Text/Text';
import Image from '../../atoms/Image/Img';
import IssuersTableStyle from './IssuersTableStyle';
import nike from '../../../assets/images/nike.svg';
import elipses from '../../../assets/images/elipses.svg';
import user from '../../../assets/images/user-male.svg';
import Pagination from '../Pagination/Pagination';
import UpdateIssuerModal from '../UpdateIssuerModal/UpdateIssuerModal';
import dayjs from 'dayjs';
import {useDispatch, useSelector} from 'react-redux';
import { TypedDispatch, RootStore } from '../../../config/ConfigStore';
import {exportData} from '../../../redux/actions/ExportAction';
import { useNavigate } from "react-router-dom";


type UserTableProps = {
  data: any,
  pagination: number,
  setPagination: Function,
  changePage: Function,
  page: number,
  reloadPage: Function
}

const IssuersTable = ({data, pagination, setPagination, changePage, page, reloadPage}: UserTableProps) => {
  const [toggleUpdateIssuerModal, setToggleUpdateIssuerModal] = useState(false);
  let timeOutId:any = null;
  const [selectedMenu, setSelectedMenu] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const dispatch: TypedDispatch = useDispatch();
  const state:any = useSelector( (state:RootStore) => state);
  const [issuerData, setissuerData] = useState({});

  const onClickHandler = (value: boolean, id: string) => {
    if(selectedMenu !== false){
      setSelectedMenu(false);
      return;
    }
    setSelectedMenu(value);
    setSelectedId(id)
  }

  const onBlurHandler = () => {

      timeOutId = setTimeout(() => {
        setSelectedMenu(false);
      });
  }

  const onFocusHandler = () =>{
      clearTimeout(timeOutId);
  }

  const showUpdateIssuerModal = () => {
    let issuerData = data.data.content.filter((data: Record<any, any>) => data.id === selectedId);
    let value = {
      ...issuerData[0]
    }
    console.log(value)
    setissuerData(value);
    setToggleUpdateIssuerModal(true);
  }

  const hideUpdateIssuerModal = () => {
    setToggleUpdateIssuerModal(false);
  }

  const renderUpdateIssuerModal = () => {
    if(toggleUpdateIssuerModal){
      return(
        <UpdateIssuerModal handleClose={hideUpdateIssuerModal} reloadPage={reloadPage} data={issuerData}/>
      )
    }
  }

  const handleAllCheck = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      await dispatch(exportData(state.dashboardReducer.results.data.content))
      console.log(state.exportReducer);
    }
    else{
      await dispatch(exportData([]));
      console.log(state.exportReducer);
    }
  };

  const handleCheckItem = (item: Record<any, any>) => {
    if(state.exportReducer.results.data.includes(item)){
      const newArr = state.exportReducer.results.data.filter( (record: Record<any,any>) => record.id !== item.id)
      console.log(newArr);
      return dispatch(exportData(newArr));
    }
    const update = [...state.exportReducer.results.data, item]
    console.log(update);
    return dispatch(exportData(update));
  };

  return (
    <>
      {renderUpdateIssuerModal()}
      <IssuersTableStyle>
        <div className={`container-full`}>
          <table>
            <thead>
              <tr className={`table-header`}>
                <th>
                  <input type="checkbox" onChange={handleAllCheck}/>
                  <Image image={nike} />
                </th>
                <th>
                  <Text value="Institution Name" className={`table-title`} />
                </th>
                <th>
                  <Text value="Bank Code" className={`table-title`} />
                </th>
                <th>
                  <Text value="Contact" className={`table-title`} />
                </th>
                <th>
                  <Text value="Bank Type" className={`table-title`} />
                </th>
                <th>
                  <Text value="Status" className={`table-title`} />
                </th>
                <th>
                  <Text value="Date Added" className={`table-title`} />
                </th>
                <th>
                  <Text value="More" className={`table-title`} />
                </th>
              </tr>
            </thead>
            <tbody className={`table-body`}>
            {
                (data.data.content !== undefined && data.data.content.length > 0) ?
                data.data.content.map((issuer: Record<any, any>, key: string) => {
                  return (
                    <tr className={`table-row`} key={key}>
                      <td>
                        <input
                          type="checkbox"
                          checked={state.exportReducer.results.data.includes(
                            issuer
                          )}
                          onChange={() => handleCheckItem(issuer)}
                        />
                        <Image image={nike} />
                      </td >
                      <td> 
                        <Text value={issuer.name} className='label' />
                      </td>
                      <td> 
                        <Text value={issuer.issuerCode} className='label' />
                      </td>
                      <td> 
                        <Text value={issuer.issuerEmail} className='label' />
                        <Text value={issuer.issuerPhone} className='sublabel' />
                      </td>
                      <td> 
                        {
                          (issuer.issuerType === 1) ? <Text value={`Commercial bank`} className='label' /> : ''
                        }
                        {
                          (issuer.issuerType === 2) ? <Text value={`Microfinance bank`} className='label' /> : ''
                        }
                        {
                          (issuer.issuerType === 3) ? <Text value={`Wallet`} className='label' /> : ''
                        }
                      </td>
                      <td> 
                        {
                          (issuer.status === 0) ? 
                          <button className='status --inactive'>
                            Inactive
                          </button> : null
                        }
                        {
                          (issuer.status === 1) ? 
                          <button className='status --active'>
                            Active
                          </button>: null
                        }
                        {
                          (issuer.status > 1) ? 
                          <button className='status --pending'>
                            Pending
                          </button> : null
                        } 
                      </td>
                      <td> 
                        <Text value={dayjs(issuer.createdDate).format('MM/DD/YYYY')} className='label' />
                        <Text value={dayjs(issuer.createdDate).format('h:mm A')} className='date' />
                      </td>
                      <td> 
                        <div className={`container-full`} onBlur={() => onBlurHandler()} onFocus={() => onFocusHandler()}>
                            <button className={`button --elipses`} onClick={() => onClickHandler(true, issuer.id)} aria-haspopup="true" aria-expanded={selectedMenu}>
                              <Image image={elipses} />
                            </button>
                            {
                                selectedMenu !== false && selectedId === issuer.id && (
                                  <div className={`container-full more-info`}>
                                    <div className={`container-full more-info__item ${
                                     state.authReducer.results.roles.includes('Administrator') ? '' : 'disabled'
                                    }`}>
                                      <button onClick={() => showUpdateIssuerModal()}>
                                        <Text value='Edit' />
                                      </button>
                                    </div> 
                                  </div>
                                )
                            }
                          </div>
                      </td>
                    </tr>
                  )
                }) : null
              }          
            </tbody>
          </table>
        </div>
        <div className={`container-full pagination`}>
          <Pagination pagination={pagination} changePage={changePage} setPagination={setPagination} page={page}/> 
        </div>
      </IssuersTableStyle>
    </>
  );
};

export default IssuersTable;
